export default [
  {
    path: '/orders',
    name: 'Orders Listing',
    component: () => import(/* webpackChunkName: "order-listing" */ '../components/orders/OrderListing.vue'),
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/orders/:id',
    name: 'Order Edit',
    component: () =>
      import(/* webpackChunkName: "order-edit" */ '../components/orders/OrderEdit.vue'),
    meta: {
      requiresAuth: true
    },
  },
];